<template>
  <a
    rel="noopener noreferrer"
    target="_blank"
    class="whatsapp-button"
    :style="style"
    :href="link"
  >
    {{content}}
  </a>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';

export default {
  mixins: [aboutMixin],
  computed: {
    style() {
      return `width: ${this.width}px; height: ${this.height}px;`;
    },
  },
  data() {
    return {
      content: '',
    };
  },
  props: {
    /**
     * @description ссылка на телеграм
     */
    link: {
      type: String,
      default: aboutMixin.supportWhatsappHref,
    },
    /**
     * @description Высота
     * @type String
     */
    height: {
      type: String,
      default: '24',
    },
    /**
     * @description Ширина
     * @type String
     */
    width: {
      type: String,
      default: '22',
    },
  },
};

</script>

<style scoped lang="scss">
  .whatsapp-button {
    flex-shrink: 0;
    background: url("@/assets/img/social/whats-app-green.svg") no-repeat center;
    background-size: contain;
    transition: 0.3s;
    &:hover {
      filter: brightness(95%) contrast(100%)
    }
    &:active {
      transform: scale(0.95);
    }
  }
</style>
